import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HotToastService } from "@ngneat/hot-toast";
import dayjs from "dayjs";
import { Observable, of, throwError } from "rxjs";
import { ComparisonOperator, Filter } from "../components/table/sortable-table/filter-form-group";

@Injectable({
  providedIn: "root",
})
export class AbstractService {
  constructor(protected http: HttpClient) {}

  serializeForQueryString(obj: any) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        if (Array.isArray(obj[p])) {
          for (var i = 0; i < obj[p].length; i++) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p][i]));
          }
        } else {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      }
    return str.join("&");
  }

  serializeForQueryStringOdata(obj: Filter) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        switch (p) {
          case "PageNumber":
            str.push("$skip=" + (obj.PageNumber - 1) * (obj.PageSize ?? 0));
            break;
          case "PageSize":
            if (obj.PageSize != null) {
              str.push("$top=" + obj.PageSize);
            }
            str.push("$count=true");
            break;
          case "OrderBy":
            if (obj.OrderBy != null) {
              let orderby = obj.OrderBy.split(",");
              orderby = orderby
                .map((orderedKey) => orderedKey.replaceAll(".", "/"))
                .map((orderKey) => orderKey + " " + (obj.SortDirection || "asc"));
              str.push("$orderby=" + orderby.join(","));
            }
            break;
          case "SortDirection":
            break;
          case "OdataFilters":
            break;
          default:
            let value = obj as any;
            if (Array.isArray(value[p])) {
              for (var i = 0; i < value[p].length; i++) {
                if (value[p][i] != null && value[p][i] != undefined)
                  str.push(encodeURIComponent(p) + "=" + encodeURIComponent(value[p][i]));
              }
            } else if (value[p] != null && value[p] != undefined && value[p] !== "") {
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(value[p]));
            }
            break;
        }
      }
    let url = str.join("&");
    if (
      obj.OdataFilters &&
      obj.OdataFilters.filter(
        (x) => x.Value != null && x.Value !== "" && x.Value !== "null" && x.Operator != undefined
      ).length > 0
    ) {
      url += "&$filter=";

      for (let p of obj.OdataFilters.filter(
        (x) => x.Value != null && x.Value !== "" && x.Value !== "null" && x.Operator != undefined
      )) {
        if (!p.IsArray) {
          if (p.Type == "date" || p.Type == "datetime") {
            if (p.Operator != ComparisonOperator.Between) {
              //ignore if not valid date
              if (!dayjs(p.Value).isValid()) {
                continue;
              }
            }
            const formatter = p.Type == "datetime" ? "datetime" : "datetimeoffset";
            switch (p.Operator) {
              case ComparisonOperator.Equal:
                if (formatter == "datetimeoffset")
                  url += `${p.Field} eq ${formatter}'${p.Value}' and `;
                else
                  url += `${p.Field} ge ${formatter}'${p.Value}' and ${p.Field} lt ${formatter}'${dayjs(p.Value).add(1, "day").format("YYYY-MM-DD")}' and `;
                break;
              case ComparisonOperator.GreaterThan:
                url += `${p.Field} gt ${formatter}'${p.Value}' and `;
                break;
              case ComparisonOperator.GreaterThanOrEqual:
                url += `${p.Field} ge ${formatter}'${p.Value}' and `;
                break;
              case ComparisonOperator.LessThan:
                url += `${p.Field} lt ${formatter}'${p.Value}' and `;
                break;
              case ComparisonOperator.LessThanOrEqual:
                url += `${p.Field} le ${formatter}'${p.Value}' and `;
                break;
              case ComparisonOperator.Between:
                const dates = p.Value?.split(",");
                if (
                  dates?.length == 2 &&
                  dates[0] &&
                  dates[1] &&
                  dates[0] != "null" &&
                  dates[1] != "null" &&
                  dates[0] != "undefined" &&
                  dates[1] != "undefined"
                ) {
                  url += `(${p.Field} ge ${formatter}'${dates[0]}' and ${p.Field} le ${formatter}'${dates[1]}') and `;
                } else {
                  if (p.Value) {
                    url += `(${p.Field} ge ${formatter}'${p.Value}') and `;
                  }
                }
                break;
            }
          } else {
            if (p.Operator == ComparisonOperator.Contains) {
              const params = p.Field.split(",");
              url += "(";
              for (let param of params) {
                url += `substringof('${p.Value}', ${param}) eq true or `;
              }
              url = url.replace(/ or $/, "");
              url += ") and ";
            } else if (p.Operator == ComparisonOperator.ContainsNot) {
              const params = p.Field.split(",");
              url += "(";
              for (let param of params) {
                url += `substringof('${p.Value}', ${param}) eq false and `;
              }
              url = url.replace(/ and $/, "");
              url += ") and ";
            } else if (p.Operator == ComparisonOperator.In) {
              console.log("in operator", p);
              const params = p.Field.split(",");
              url += "(";
              for (let param of params) {
                url += `${param} eq ${p.Value} or `;
              }
              url = url.replace(/ or $/, "");
              url += ") and ";
            } else {
              if (p.Value == "empty") {
                url += p.Field + " " + p.Operator + " null and ";
              } else {
                url += p.Field + " " + p.Operator + " " + p.Value + " and ";
              }
            }
          }
        } else {
          {
            if (p.Property) {
              if (p.Value == "empty") {
                url += `${p.Property}/any(x: x/${p.Field} ${p.Operator} null) and `;
              } else {
                url += `${p.Property}/any(x: x/${p.Field} ${p.Operator} ${p.Value}) and `;
              }
            }
          }
        }
      }
      if (url.endsWith("$filter=")) {
        url = url.replace("$filter=", "");
      }
    }
    url = url.replace(/ and $/, "");
    return url;
  }

  reThrowError(err: any) {
    console.log("caught mapping error and rethrowing", err);
    //  return of(err.message);
    return throwError(err);
  }
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  handleError<T>(result?: T) {
    return (error: any): Observable<T> => {
      //in de AuthInterceptor worden de error afgevangen en een toaster getoond.

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(error.message);
    };
  }
  downloadResource(resourceUrl: string) {
    return this.http.get(resourceUrl, { responseType: "blob" });
  }

  /**
   * Downloads a file from the given URL and saves it with the specified filename.
   * Optionally, displays toast notifications for loading, success, and error states.
   *
   * @param url - The URL of the resource to download.
   * @param filename - The name to save the downloaded file as.
   * @param toast - Optional HotToastService instance for displaying notifications.
   * @param toastLoading - Message to display while downloading.
   * @param toastSuccess - Message to display on successful download.
   * @param toastError - Message to display on error during download.
   */
  downloadFile(
    url: string,
    filename: string,
    toast: HotToastService | null = null,
    toastLoading = "Bezig met downloaden",
    toastSuccess = "Gedownload",
    toastError = "Iets ging mis"
  ) {
    this.downloadBlob(
      this.downloadResource(url),
      filename,
      toast,
      toastLoading,
      toastSuccess,
      toastError
    );
  }

  downloadBlob(
    blobObservable: Observable<Blob>,
    filename: string,
    toast: HotToastService | null = null,
    toastLoading = "Bezig met downloaden",
    toastSuccess = "Gedownload",
    toastError = "Iets ging mis"
  ) {
    if (toast) {
      blobObservable = blobObservable.pipe(
        toast.observe({
          loading: toastLoading,
          success: toastSuccess,
          error: toastError,
        })
      );
    }

    blobObservable.subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    });
  }
}
